import LatLngCalc from '../../components/Leaflet/consts/latLngCalc';

// Types
export const LeafletTypes = {
    UPDATE_AREA: 'leaflet/UPDATE_AREA',
    SHOW_CONTAINER_MODAL: 'leaflet/SHOW_CONTAINER_MODAL',
    SHOW_ERROR_MODAL: 'leaflet/SHOW_ERROR_MODAL',
    RESET: 'leaflet/RESET',
    UPDATE_COORD: 'leaflet/UPDATE_COORD'
};

// Reducer
const INITIAL_STATE = {
    viewport: {
        center: [0, 0],
        zoom: 18
    },
    containerModalState: {
        show: false,
        area: 0,
        salvarButton: false,
        isOnlyView: false
    },
    errorModalState: {
        show: false,
        message: null
    }
};

export function leafletReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case LeafletTypes.UPDATE_COORD:
            return {
                ...state,
                viewport: {
                    ...state.viewport,
                    center: [LatLngCalc(action.payload.lat), LatLngCalc(action.payload.lng)]
                }
            };
        case LeafletTypes.UPDATE_AREA:
            return { ...state, containerModalState: { ...state.containerModalState, area: action.payload.area } };
        case LeafletTypes.SHOW_CONTAINER_MODAL:
            return {
                ...state,
                containerModalState: {
                    ...state.containerModalState,
                    show: action.payload.modalState,
                    isOnlyView: action.payload.view,
                    fromHistorico: action.payload.fromHistorico
                }
            };
        case LeafletTypes.SHOW_ERROR_MODAL:
            return {
                ...state,
                errorModalState: {
                    ...state.errorModalState,
                    show: action.payload.modalState,
                    message: action.payload.msg
                }
            };
        case LeafletTypes.RESET:
            return { ...INITIAL_STATE };
        default:
            return state;
    }
}

// Actions
export const Creators = {
    updateCoord: (lat, lng) => ({
        type: LeafletTypes.UPDATE_COORD,
        payload: {
            lat,
            lng
        }
    }),
    updateArea: (area) => ({
        type: LeafletTypes.UPDATE_AREA,
        payload: {
            area
        }
    }),
    showContainerModal: (show, isOnlyView = false, fromHistorico = false) => ({
        type: LeafletTypes.SHOW_CONTAINER_MODAL,
        payload: {
            modalState: show,
            view: isOnlyView,
            fromHistorico: fromHistorico
        }
    }),
    showErrorModal: (show, msg) => ({
        type: LeafletTypes.SHOW_ERROR_MODAL,
        payload: {
            modalState: show,
            msg
        }
    }),
    reset: () => ({
        type: LeafletTypes.RESET
    })
};
